import { useLazyQuery } from '@apollo/client';
import useEnableFastifyApi from './useEnableFastifyApi';
import { GET_CRUISE } from '../queries';
import restRequest from './restClient';
import useAsyncCall from './useAsyncCall';

function toGraphqlShape(bffResponse) {
  return { cruise: bffResponse };
}

export default function useCruiseInfo(options) {
  const enableFastifyApi = useEnableFastifyApi();

  const graphqlResult = useLazyQuery(GET_CRUISE, options);
  const [restExecute, restState] = useAsyncCall(
    ({ variables: { cruiseId, filters } = {} } = {}) =>
      restRequest({ path: `/air-api/v1/cruises/${cruiseId}`, params: { filters } }).then(
        toGraphqlShape,
      ),
    options,
  );

  if (enableFastifyApi) {
    return [restExecute, restState];
  }
  return graphqlResult;
}
